<template>
    <div class="bg-white rounded-sm mx-2 my-3">
        <div class="grid grid-cols-12 gap-4">

            <div class="col-span-12">

                <div class="grid grid-cols-12 gap-4">
                    <AppModal v-model="showStrikeCompanyModal" size="lg" title="Add new MDA to register">
                        <div class="grid grid-cols-12 gap-4">
                            <div class="col-span-12 mx-auto mb-2">
                                <div class="border-b border-gray-200">
                                    <nav class="flex space-x-6 px-4" aria-label="Tabs">
                                        <div :class="[(option === 'form') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']"
                                             @click="select('form')">
                                            <div class="flex mt-6">
                                                <div style="font-size: 14px" class="mt-1">Name of MDA/Entity</div>
                                            </div>
                                        </div>
                                    </nav>
                                </div>
                            </div>
                        </div>
                        <div class="grid grid-cols-12 gap-4">
                            <div class="col-span-12 mx-auto">
                                <form v-if="option === 'form'">
                                    <input
                                        type="text"
                                        class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                                        v-model="form.name"
                                        placeholder="Name of MDA here"
                                        rows="6">
                                    </input>


                                    <button class="btn-primary bg-primary text-white px-3 py-1 rounded-sm mt-2 float-end" @click="save"
                                            type="button">
                                        Submit
                                        <span class="lds-ring" v-if="spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </span>
                                    </button>
                                </form>
                            </div>
                        </div>
                    </AppModal>
                </div>
                <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-12">
                        <div class="grid grid-cols-12 gap-4">
                            <div class="col-span-10"></div>
                            <div class="col-span-2">
                                <button class="btn-primary w-full bg-primary text-white px-2 py-1 rounded-sm text-sm"
                                        @click="openForm"><i
                                        class="fa fa-plus"></i>
                                    Add MDA/Entity
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
                <EntityWrapper/>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import AppModal from "@/components/ui/AppModal.vue";
import EntityWrapper from "@/domains/home/services/registry/business/EntityWrapper.vue";
import { api } from "@/app/services/api.service.ts";
import { useToast } from "@/composables";
import { useBusinessRegistryStore } from "@/stores/business-registry.ts";

interface Form {
    name: string | null
}

const store = useBusinessRegistryStore();
const { successToast, errorToast } = useToast()

const showStrikeCompanyModal = ref(false)
const form = ref<Form>({
    name: null
})
const option = ref("form")
const spinner = ref(false)

const select = (route: string) => {
    option.value = route
}

const openForm = () => {
    showStrikeCompanyModal.value = true
}

const save = async () => {
    spinner.value = true

    await api().post("/configuration/mda-registry", form.value)
        .then(response => {
            successToast("Success", response.data.message || "MDA/Entity added successfully")
            spinner.value = false
            form.value.name = null
          store.fetchMDAListRegistry({
                search: "",
                page: 1,
                limit: 10,
                offset: 10
            })
        }).catch(error => {
            errorToast("Error ", error.response?.data?.message || "Failed to add MDA/Entity")
            spinner.value = false
        })
}

// Watchers
watch(() => store.entity_file, (data) => {
    if (data) {
        successToast("Success", "Added files to black list")
        window.location.reload()
    }
})
</script>
